// extracted by mini-css-extract-plugin
module.exports = {"container":"signup_container__3z6b-","back":"signup_back__Grv1P","accept":"signup_accept__2Elr3"};